import type { YMaps } from '@cian/frontend-ymaps-components/es/types/ymaps';

import { ICoordinates } from '../../../types/newbuildingsCompare';

/** Центр Москвы — запасной центр, если координат нет вовсе. */
const FALLBACK_CENTER: YMaps.LngLat = [37.618423, 55.751244];
const FALLBACK_ZOOM = 10;
const SINGLE_PIN_ZOOM = 15;

/** В API Яндекса координаты идут в порядке [долгота, широта]. */
export function toLngLat({ lat, lng }: ICoordinates): YMaps.LngLat {
  return [lng, lat];
}

/**
 * Начальное положение карты: показываем все пины сразу. Для набора точек отдаём bounds —
 * карта сама подберёт зум (поля по краям задаются пропом `margin` у `YMap`).
 */
export function getMapLocation(coordinates: ICoordinates[]): YMaps.YMapLocationRequest {
  if (!coordinates.length) {
    return { center: FALLBACK_CENTER, zoom: FALLBACK_ZOOM };
  }

  const lngs = coordinates.map(item => item.lng);
  const lats = coordinates.map(item => item.lat);
  const minLng = Math.min(...lngs);
  const maxLng = Math.max(...lngs);
  const minLat = Math.min(...lats);
  const maxLat = Math.max(...lats);

  // Один пин или все ЖК в одной точке: bounds нулевого размера карта растянула бы до максимального зума.
  if (minLng === maxLng && minLat === maxLat) {
    return { center: toLngLat(coordinates[0]), zoom: SINGLE_PIN_ZOOM };
  }

  // bounds в API Яндекса — это [верхний левый угол, нижний правый], то есть [[minLng, maxLat], [maxLng, minLat]].
  return {
    bounds: [
      [minLng, maxLat],
      [maxLng, minLat],
    ],
  };
}
